// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для контейнера пагинации */
.footer-pagination-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #e8e8e8;
    box-sizing: border-box;
  }
  
  /* Стили для информации о количестве приложений */
  .page-info {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    width: 33%;
  }
  
  /* Стили для селектора количества строк */
  .page-size-selector {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 33%;
    justify-content: flex-end;
  }
  
  .page-size-selector span {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  
  /* Новый унифицированный список пагинации */
  .pagination-list {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 33%;
    justify-content: center;
  }
  
  .pagination-item {
    margin: 0 2px;
    display: inline-block;
    vertical-align: middle;
  }
  
  .pagination-ellipsis {
    display: inline-block;
    line-height: 24px;
    height: 24px;
    width: 24px;
    text-align: center;
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.65);
  }
  
  /* Кнопка активной страницы */
  .pagination-active {
    background-color: #e74c3c !important;
    border-color: #e74c3c !important;
    color: white !important;
  }
  
  /* Стили для кнопок стрелок */
  .nav-button {
    width: 24px !important;
    height: 24px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  /* Убрать синий фон */
  .nav-button, 
  .pagination-list .ant-btn {
    background-color: white !important;
    box-shadow: none !important;
  }
  
  /* Стиль для активной кнопки страницы */
  .pagination-list .ant-btn-primary {
    background-color: #e74c3c !important;
    border-color: #e74c3c !important;
  }
  
  /* Исправление для иконок */
  .nav-button .anticon {
    font-size: 10px !important;
    vertical-align: middle !important;
    line-height: 1 !important;
  }`, "",{"version":3,"sources":["webpack://./src/styles/CustomePagitation.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA,iDAAiD;EACjD;IACE,0BAA0B;IAC1B,eAAe;IACf,UAAU;EACZ;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,6BAA6B;EAC7B;IACE,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA,qBAAqB;EACrB;;IAEE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA,uCAAuC;EACvC;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA,2BAA2B;EAC3B;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,yBAAyB;EAC3B","sourcesContent":["/* Стили для контейнера пагинации */\r\n.footer-pagination-container {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 16px;\r\n    background-color: #ffffff;\r\n    border-top: 1px solid #e8e8e8;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  /* Стили для информации о количестве приложений */\r\n  .page-info {\r\n    color: rgba(0, 0, 0, 0.65);\r\n    font-size: 14px;\r\n    width: 33%;\r\n  }\r\n  \r\n  /* Стили для селектора количества строк */\r\n  .page-size-selector {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    width: 33%;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  .page-size-selector span {\r\n    color: rgba(0, 0, 0, 0.65);\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Новый унифицированный список пагинации */\r\n  .pagination-list {\r\n    display: flex;\r\n    align-items: center;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 33%;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .pagination-item {\r\n    margin: 0 2px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n  }\r\n  \r\n  .pagination-ellipsis {\r\n    display: inline-block;\r\n    line-height: 24px;\r\n    height: 24px;\r\n    width: 24px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    color: rgba(0, 0, 0, 0.65);\r\n  }\r\n  \r\n  /* Кнопка активной страницы */\r\n  .pagination-active {\r\n    background-color: #e74c3c !important;\r\n    border-color: #e74c3c !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  /* Стили для кнопок стрелок */\r\n  .nav-button {\r\n    width: 24px !important;\r\n    height: 24px !important;\r\n    padding: 0 !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n  }\r\n  \r\n  /* Убрать синий фон */\r\n  .nav-button, \r\n  .pagination-list .ant-btn {\r\n    background-color: white !important;\r\n    box-shadow: none !important;\r\n  }\r\n  \r\n  /* Стиль для активной кнопки страницы */\r\n  .pagination-list .ant-btn-primary {\r\n    background-color: #e74c3c !important;\r\n    border-color: #e74c3c !important;\r\n  }\r\n  \r\n  /* Исправление для иконок */\r\n  .nav-button .anticon {\r\n    font-size: 10px !important;\r\n    vertical-align: middle !important;\r\n    line-height: 1 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
